import { apiCrm } from '../../../../http';

class SchedulingService {
  getSchedulingAnalytics(params = {}) {
    return apiCrm.get(`/report/scheduling`, {
      params
    });
  }
  getSchedulingAnalyticsCsv(params = {}) {
    return apiCrm.get(`/report/scheduling/csv`, {
      responseType: 'blob',
      params
    });
  }
  getSchedulingAnalyticsXlsx(params = {}) {
    return apiCrm.get(`/report/scheduling/xlsx`, {
      responseType: 'blob',
      params
    });
  }
}

export default new SchedulingService();
